import { Loader, Pill, Tooltip } from '@recruit-robin/robin-theme/web-components';
import { MailOpened } from '@recruit-robin/robin-theme/web-icons';
import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { SnackbarContext } from 'shared/legacy/contexts/SnackbarContext/SnackbarContext';
import { useGetUnreadConversationsAmount } from 'shared/legacy/hooks/useGetUnreadConversationsAmount';
import { useMarkBatchAsReadMutation } from 'shared/legacy/hooks/useMarkBatchAsReadMutation';
import { useInboxStore } from 'stores/inbox/inbox.store';
import { InboxFilters } from '../../CentralInbox.types';
import { useStyles } from './InboxConversationListFilters.styles';

export const InboxConversationListFilters = () => {
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);
  const selectedFilter = useInboxStore((state) => state.selectedFilter);
  const setSelectedFilter = useInboxStore((state) => state.setSelectedFilter);
  const batchReadMutation = useMarkBatchAsReadMutation();
  const teamView = useInboxStore((s) => s.isTeamViewEnabled);
  const { createSnackbar } = useContext(SnackbarContext);
  const { data: unreadAmount } = useGetUnreadConversationsAmount(teamView);

  return (
    <div css={classes.root}>
      <div css={classes.filters}>
        <Pill
          style="icon-removable"
          padding="text"
          label={dictionary.all}
          type={selectedFilter === InboxFilters.ALL ? 'default' : 'subtle-lighter'}
          onClick={() => setSelectedFilter(InboxFilters.ALL)}
        />
        <Pill
          style="icon-removable"
          padding="text"
          label={dictionary.unread}
          type={selectedFilter === InboxFilters.UNREAD ? 'default' : 'subtle-lighter'}
          onClick={() => setSelectedFilter(InboxFilters.UNREAD)}
        />
        <Pill
          style="icon-removable"
          padding="text"
          label={dictionary.sent}
          type={selectedFilter === InboxFilters.SENT ? 'default' : 'subtle-lighter'}
          onClick={() => setSelectedFilter(InboxFilters.SENT)}
        />
      </div>
      {!teamView && (
        <div
          onClick={() => {
            if (unreadAmount === 0) return;
            batchReadMutation.mutateAsync().then(() => {
              createSnackbar(dictionary.successfull, { variant: 'success' });
            });
          }}>
          <Tooltip
            customCss={[classes.allAsRead, unreadAmount === 0 ? classes.allAsReadDisabled : undefined]}
            offset={10}
            label={dictionary.markAllAsRead}>
            {batchReadMutation.isLoading ? <Loader size={16} /> : <MailOpened size={16} />}
          </Tooltip>
        </div>
      )}
    </div>
  );
};
